import React from 'react';
import { CommonDeleteModal } from 'components';
import { useDeleteModal } from './useDeleteModal';

interface DeleteModal {
  openModal: boolean;
  isSubTable: boolean | undefined;
  record: Record<string, any> | undefined;
  onDeleteModalClose: (id?: string) => void;
}

export const DeleteModal = (props: DeleteModal) => {
  const { openModal, onDeleteModalClose, record, isSubTable } = props;
  const { onRemoveConfirm, isLoading } = useDeleteModal(onDeleteModalClose);
  return (
    <CommonDeleteModal
      onCancel={() => onDeleteModalClose()}
      open={openModal}
      isLoading={isLoading}
      onOk={() => onRemoveConfirm(record)}
      onClose={() => onDeleteModalClose()}
      title={'Delete Commercial Offer Item'}
      message={
        isSubTable
          ? 'Are you sure you want to delete the Commercial Offer Item?'
          : 'Deleting this Commercial Offer Item will also remove all related alternatives and substitutes that were created from it. Are you sure you want to delete the Commercial Offer Item?'
      }
    />
  );
};
